import {
  authConstants,
  commonConstants,
  profileConstants,
} from "../_constants";

const INITIAL_EXCHANGE_RATE_STATE = {
  convertedAmount: null,
  variableCurrencyUnits: null,
  fixedCurrencyCode: null,
  getExchangeRateStatus: null,
  statmentBlob: [],
  downloadReceiptType: null,
};

const INITIAL_BANK_LIST_STATE = {
  bankList: {},
  getBankListStatus: null,
};

export function bankListReducer(state = INITIAL_BANK_LIST_STATE, action) {
  switch (action.type) {
    case commonConstants.BANK_LIST_REQUEST:
      return {
        bankList: {},
        getBankListStatus: null,
      };
    case commonConstants.BANK_LIST_COMPLETE:
      return {
        bankList: action.payload.data.bankList,
        getBankListStatus: "completed",
      };
    case commonConstants.RESET_BANK_LIST:
      return INITIAL_BANK_LIST_STATE;
  }

  return state;
}

const INITIAL_RECEIPT_DOWNLOAD_STATE = {
  statmentBlob: [],
  downloadReceiptType: null,
  downloadReference: null,
  fileName: null,
  status: null,
  downloadError: false,
};

export function receiptDownloadReducer(
  state = INITIAL_RECEIPT_DOWNLOAD_STATE,
  action,
) {
  switch (action.type) {
    case commonConstants.GET_RECEIPT_DOWNLOAD_PATH_COMPLETE:
      return {
        ...state,
        downloadReference: action.payload.data.downloadReference,
      };
    case commonConstants.RECEIPT_DOWNLOAD_COMPLETE:
      return {
        ...state,
        statmentBlob: action.payload.data,
        downloadReceiptType: action.payload.type,
      };
    case commonConstants.RECEIPT_DOWNLOAD_ERROR:
      return {
        ...state,
        downloadError: true,
      };
    case commonConstants.GET_RECEIPT_DOWNLOAD_STATUS_COMPLETE:
      return {
        ...state,
        status: action.payload.data.response.jasperReportStatusCheckDto.status,
        fileName:
          action.payload.data.response.jasperReportStatusCheckDto.status ==
          "COMPLETED"
            ? action.payload.data.response.jasperReportStatusCheckDto.fileName
            : null,
      };
    case commonConstants.RESET_RECEIPT_DOWNLOAD_STATUS:
      return INITIAL_RECEIPT_DOWNLOAD_STATE;
  }

  return state;
}

const INITIAL_FIRST_TIME_LOGIN_STATE = {
  isFirstTimeLogin: false,
};

export function firstTimeLoginReducer(
  state = INITIAL_FIRST_TIME_LOGIN_STATE,
  action,
) {
  switch (action.type) {
    case commonConstants.SET_FIRST_TIME_LOGIN_STATE:
      return {
        isFirstTimeLogin: action.payload,
      };
  }

  return state;
}

const COMMON_DATA_STATE = {
  nickName: null,
  forgotRecoveredUsername: null,
  customerTier: null,
};

export function commonDataReducer(state = COMMON_DATA_STATE, action) {
  switch (action.type) {
    case authConstants.AUTH_LOGIN_REQUEST:
      return {
        ...state,
        nickName: null,
        forgotRecoveredUsername: null,
      };

    case authConstants.OTP_CONFIRM_REQUEST:
      return {
        ...state,
        nickName: null,
        forgotRecoveredUsername: null,
      };

    case authConstants.AUTH_LOGIN_COMPLETE:
      return {
        ...state,
        nickName: action?.payload?.userDetails?.nickName,
        customerTier: action?.payload?.userDetails?.customerTier,
        forgotRecoveredUsername: null,
      };

    case authConstants.OTP_CONFIRM_COMPLETE:
      return {
        ...state,
        nickName: action?.payload?.data?.nickName,
        customerTier: action?.payload?.data?.customerTier,
        forgotRecoveredUsername: null,
      };

    case profileConstants.UPDATE_DISPLAY_NAME_COMPLETE:
      return {
        ...state,
        nickName: action.payload?.data?.customer?.nickname,
      };

    case authConstants.FORGOT_USERNAME_OTP_CONFIRM_COMPLETE:
      return {
        ...state,
        forgotRecoveredUsername: action?.payload?.data?.customer?.userName,
      };

    case profileConstants.GET_PROFILE_DETAILS_COMPLETE:
      return {
        ...state,
        nickName: action.payload?.data?.customer?.nickname,
        profilePicturePath: action.payload?.data?.customer?.profilePicturePath,
        forgotRecoveredUsername: null,
      };
  }

  return state;
}

const INITIAL_HAS_CHANGED_FORM_STATE = {
  hasFormChanged: false,
};

export function hasChangedFormReducer(
  state = INITIAL_HAS_CHANGED_FORM_STATE,
  action,
) {
  switch (action.type) {
    case commonConstants.COMMON_HAS_CHANGED_FORM:
      return {
        ...state,
        hasFormChanged: action.payload,
      };
    case commonConstants.RESET_HAS_CHANGED_FORM:
      return INITIAL_HAS_CHANGED_FORM_STATE;
  }

  return state;
}
